interface MenuItem {
    name: string;
    url?: string,
    children?: MenuItem[];
}
export const buildMenuTree = (items: any[]): MenuItem[] => {
    const map: { [key: number]: MenuItem } = {};
    const roots: MenuItem[] = [];

    items.forEach(item => {
        // Создаем объект для каждого элемента меню
        const menuItem: MenuItem = {name: item.name, url: item.url};
        map[item.key] = menuItem;

        // Если у элемента есть родитель, добавляем его в children
        if (item.parent === 0) {
            roots.push(menuItem); // Это корневой элемент
        } else {
            if (!map[item.parent].children) {
                map[item.parent].children = [];
            }
            map[item.parent].children?.push(menuItem);
        }
    });

    return roots;
};